import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { IRecordAsSeenBy } from 'src/app/common/models/IRecordAsSeenBy';
import { SetRecordAsSeenBy, ClearRecordAsSeenBy } from './record-as-seen-by.actions';


export class RecordAsSeenByStateModel {
  data: IRecordAsSeenBy;
}

@State<RecordAsSeenByStateModel>({
    name: 'recordAsSeenBy',
    defaults: {
      data: null
    }
})

@Injectable()
export class RecordAsSeenByState {

    @Selector()
    static getRecordAsSeenByState(state: RecordAsSeenByStateModel) {
        return state;
    }

    @Action(SetRecordAsSeenBy)
    public setRecordAsSeenBy({ getState, setState }: StateContext<RecordAsSeenByStateModel>,
       { data }: SetRecordAsSeenBy) {
        const state = getState();
        setState({ ...state, data });
    }

    @Action(ClearRecordAsSeenBy)
    public clearRecordAsSeenBy({ getState, setState }: StateContext<RecordAsSeenByStateModel>) {
        const state = getState();
        setState({ ...state, data: null });
    }
}
